// tripLookup.js
// -----------------------------------------------------------------------------
// The multi-day trips running on a day, read from the TRIP documents --
// upcountryTrip and outOfAreaTrip carry dates, plates and groups, no customer
// data -- so the driver app (and the monitor board) can find a trip without
// loading every truck's deliveryList rows across several days. The judgement
// is driverDay.openTripKeys. Equality-only queries: no index.
// -----------------------------------------------------------------------------
import { db } from '@/firebase'
import D from '@/components/driverDay'
import DR from '@/components/deliveryRow'

async function readOpenTrips (today, { overdueDays } = {}) {
  const [up, routes] = await Promise.all([
    db.collection('upcountryTrip').where('status', '==', 'sent').get(),
    // A 2-day route that is on its second day left yesterday.
    db.collection('outOfAreaTrip').where('date', '==', DR.addDays(today, -1)).get()
  ])
  const upTrips = []
  up.forEach(d => upTrips.push(Object.assign({ id: d.id }, d.data())))
  const rs = []
  routes.forEach(d => rs.push(Object.assign({ id: d.id }, d.data())))
  return D.openTripKeys({ upTrips, routes: rs, today, overdueDays })
}

export default { readOpenTrips }
